document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initProducto();
});

function initReveal() {
  const els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach((el) => el.classList.add('mt-visible'));
    return;
  }
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );
  els.forEach((el) => io.observe(el));
}

function initProducto() {
  const root = document.querySelector('[data-mt-producto]');
  if (!root) return;

  // --- Galeria: click en miniatura cambia la imagen principal ---
  const principal = root.querySelector('[data-mt-principal]');
  const thumbs = root.querySelectorAll('[data-mt-thumb]');
  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const src = thumb.getAttribute('data-full');
      if (principal && src) principal.src = src;
      thumbs.forEach((t) => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });

  // --- Variantes ---
  const variantsData = root.querySelector('[data-mt-variants-json]');
  const idInput = root.querySelector('[data-mt-variant-id]');
  const precioEl = root.querySelector('[data-mt-precio]');
  const compareEl = root.querySelector('[data-mt-precio-compare]');
  const submitBtn = root.querySelector('[data-mt-submit]');
  const dispoEl = root.querySelector('[data-mt-disponibilidad]');
  const optionButtons = root.querySelectorAll('[data-mt-option]');

  let variants = [];
  try {
    variants = variantsData ? JSON.parse(variantsData.textContent) : [];
  } catch (e) {
    variants = [];
  }

  function money(cents) {
    return (cents / 100).toLocaleString(document.documentElement.lang || 'es', {
      style: 'currency',
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR',
    });
  }

  function currentSelection() {
    const sel = {};
    root.querySelectorAll('[data-mt-option-group]').forEach((group) => {
      const active = group.querySelector('.is-active');
      if (active) sel[group.getAttribute('data-mt-option-group')] = active.getAttribute('data-mt-option');
    });
    return sel;
  }

  function findVariant() {
    const sel = currentSelection();
    return variants.find((v) => v.options.every((val, i) => sel[i] === undefined || sel[i] === val));
  }

  function updateUI() {
    const variant = findVariant();
    if (!variant) return;
    if (idInput) idInput.value = variant.id;
    if (precioEl) precioEl.textContent = money(variant.price);
    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = money(variant.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
    if (submitBtn) {
      submitBtn.disabled = !variant.available;
      submitBtn.textContent = variant.available
        ? submitBtn.getAttribute('data-text-add')
        : submitBtn.getAttribute('data-text-sold-out');
    }
    if (dispoEl) {
      dispoEl.textContent = variant.available
        ? dispoEl.getAttribute('data-text-in-stock')
        : dispoEl.getAttribute('data-text-sold-out');
      dispoEl.classList.toggle('agotado', !variant.available);
    }
  }

  optionButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const group = btn.closest('[data-mt-option-group]');
      group.querySelectorAll('[data-mt-option]').forEach((b) => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      updateUI();
    });
  });

  // --- Cantidad ---
  const qtyInput = root.querySelector('[data-mt-qty-input]');
  root.querySelectorAll('[data-mt-qty-btn]').forEach((btn) => {
    btn.addEventListener('click', () => {
      if (!qtyInput) return;
      const dir = btn.getAttribute('data-mt-qty-btn') === 'plus' ? 1 : -1;
      const next = Math.max(1, parseInt(qtyInput.value || '1', 10) + dir);
      qtyInput.value = next;
    });
  });

  if (variants.length) updateUI();
}
